// removed by extract-text-webpack-plugin
module.exports = {"item":"_3CR27QO9oV7Clfi3qWTT55","popoverContainer":"_1b_iFyoFvt-jZlHzr3pz21","name":"_1YsdW16L1UhXPO5JVYVz8-","lockedIcon":"qJMYb_J7704p9I0Ab8xm8","shown":"_8hqS0QvKId74WDnbgpOze","popoverContent":"WOZPUarlVDoBxezRI9jYD","popoverItem":"_18Sk5T4ij1lM5h3KkQslif","selected":"_3s4_DuryInw_lRhZWXTy4J"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Groups/GroupPage/Roles/style/RoleItem.pcss
// module id = 1409
// module chunks = 0